export default "__VITE_ASSET__CqR4iz_U__"